import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import ClientQueriesPromo from '../../../../assets/images/upsell-client-queries.png'

export const ClientQueriesUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={ClientQueriesPromo} alt='Client Queries promo' className='zocks-border-0.5 w-100 object-fit-contain' />}
      heading={
        <>
          Find untapped growth with <span className='zocks-text-primary'>Client Queries</span>
        </>
      }
      description='Search your whole book in seconds, from CRM to meeting notes. See where the opportunities are.'
    />
  )
}

export const ClientQueriesUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Find hidden opportunities' description='Find held-away assets, planning gaps, and upcoming life events across your book' />
      <UpsellFeatureItem
        title='Every system at once'
        description='Search CRM, financial planning, custodian data, and every captured conversation in one query'
      />
      <UpsellFeatureItem
        title='Built-in actions'
        description='Tag, add tasks, send personalized emails, or export the list, right from the results'
        className='mb-3'
      />
    </>
  )
}
